'use strict';
// import './style.css';

export class OrderPropsForm
{
    constructor(options = [])
    {
        this.options = options;
        this.init();
    }

    init()
    {
        const instance = this

        let profileAddForm = document.getElementById('profile-add-jur')
        if (profileAddForm) {
            profileAddForm.addEventListener('submit', function (e) {
                e.preventDefault()
                let form = this
                instance.sendForm(form)
            });
        }

    }

    async sendForm(form) {

        let url = form.getAttribute('action')
        let formData = new FormData(form)

        await fetch(url, {
            method: 'POST',
            body: formData,
            mode: 'cors'
        }).then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                    return;
                }
                response.text().then(function(data) {
                    let legalBlocks = document.querySelectorAll('.legal-block-toggle')
                    if (legalBlocks) {
                        legalBlocks.forEach((block) => block.classList.toggle('d-none'))
                    }
                    document.querySelector('.js-jur-block').innerHTML = data
                }).catch(function(err) {
                    console.log('Fetch Error :-S', err);
                });
            }
        );

    }
}